<template>
  <button class="close-btn" @click="this.closeModal"><CrossClose /></button>
</template>

<script>
import CrossClose from 'components/icons/CrossClose'
export default {
  name: 'CloseModalBtn',
  props: ['closeModal'],
  components: { CrossClose },
}
</script>

<style lang="scss" scoped>
.close-btn {
  width: 50px !important;
  height: 50px !important;
  display: flex;
  justify-content: center;
  align-items: center;
  right: 0;
  top: 0;
  position: absolute;
  height: max-content;
  svg {
    margin: 0;
  }
  &:hover {
    svg:deep() {
      path {
        fill: #ec1b0e;
      }
    }
  }
}
</style>
